import { AssignedCourseSummary, CourseProgressData } from "types";

export type LearnerCourseState = "locked" | "completed" | "in_progress" | "not_started" | "unavailable";

export const learnerCourseHasOutline = (progress?: CourseProgressData) => Boolean(progress && Array.isArray(progress.flows));

export function learnerCourseComplete(summary: AssignedCourseSummary, progress?: CourseProgressData): boolean {
  const total = progress?.flows?.length ?? progress?.total_flows ?? summary.total_flows;
  if (total === 0) return false;
  return Boolean(progress?.completed_at || summary.status === "completed" || progress?.status === "completed" ||
    (progress?.progress_percent ?? summary.progress_percent) >= 100 ||
    (progress?.flows?.length && progress.flows.every((flow) => flow.completed_at)));
}

export function learnerCourseState(summary: AssignedCourseSummary, progress?: CourseProgressData): LearnerCourseState {
  if ((summary.eligibility ?? progress?.eligibility)?.is_locked) return "locked";
  if (learnerCourseComplete(summary, progress)) return "completed";
  const validSummary = summary.total_flows !== undefined || summary.has_started !== undefined || summary.status !== undefined;
  if (!progress && !validSummary) return "unavailable";
  const started = summary.has_started || (summary.completed_flows ?? 0) > 0 ||
    (progress?.progress_percent ?? summary.progress_percent) > 0 || progress?.flows?.some((flow) =>
      flow.completed_at || flow.has_started || (flow.response_count ?? 0) > 0 ||
      (flow.last_accessed_at && Number.isFinite(Date.parse(flow.last_accessed_at))));
  return started ? "in_progress" : "not_started";
}
